export enum LocationEntityType{
    MasterPlanLocation = 1,
    PlanLocation = 2,
  }